/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react"
import { Close, ReplayOutlined, Visibility, VisibilityOff } from "@mui/icons-material"
import { Dialog, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, IconButton, InputAdornment, InputLabel, OutlinedInput, Radio, RadioGroup, Slide, TextField, Tooltip } from "@mui/material"
import { WtColor } from "../constants/colours"
import { Logout } from "../controller/caller"
import { loginAPI } from "../apis/APIs"
import { Env } from "../controller/constant"
import { Col, Container, Row, Spinner } from "react-bootstrap"
import { useContext } from "react"
import chatContext from "../context/chat/chatContext"
import globalContext from "../context/global/globalContext"
import moment from "moment"
import { ShowDateFilter } from "../controller/BaseTool"


const Transition = React.forwardRef(function Transition(props, ref) { return <Slide direction="up" ref={ref} {...props} /> })
const CancelButtonStyle = { color: WtColor.TextMidGrey, fontWeight: "bold" }
const ValidButtonStyle = { background: WtColor.LineColor, color: WtColor.BaseColor, fontWeight: "bold" }
// const InValidButtonStyle = { color: WtColor.BaseColor, fontWeight: "bold" }

// Pricing - HomePage
export function PricingFeaturesDialog({ open, title, message, onClose }) {
    const onCloseHere = (confirm) => { if (onClose) onClose(confirm) }
    return (
        <Dialog open={open} fullWidth={true} maxWidth={"sm"} onClose={() => onCloseHere(false)} TransitionComponent={Transition}>
            <DialogTitle style={{ background: WtColor.LineColor, color: WtColor.TextMidGrey }}>
                {title}<Close className="float-end hand" onClick={() => onCloseHere(false)} />
            </DialogTitle>
            <DialogContent>
                <DialogContentText className="mt-3" style={{ color: WtColor.TextMidGrey, fontWeight: "18px" }} dangerouslySetInnerHTML={{ __html: message }}></DialogContentText>
                <br />
                <hr />
                <button style={CancelButtonStyle} onClick={() => onCloseHere(false)} className="btn btn-sm me-3 rounded-3 ps-3 pe-3 pb-1 bg-white">Close</button>
            </DialogContent>
        </Dialog>
    )
}
// End of Pricing - HomePage


// Login Dialog
export function LoginDialog({ open, onClose }) {
    const onCloseHere = (confirm) => { if (onClose) onClose(confirm) }

    const [values, setValues] = useState({ email: '', password: '', showPassword: false })
    const handleChange = (prop) => (event) => { setValues({ ...values, [prop]: event.target.value }) }

    const [startSpinner, setStartSpinner] = useState(false)
    const handleSpinner = () => setStartSpinner(!startSpinner)

    const handleClickShowPassword = () => { setValues({ ...values, showPassword: !values.showPassword, }) }
    const handleMouseDownPassword = (event) => { event.preventDefault() }

    const handleOnKeyDown = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault()
            if (values.email !== "" || values.password !== "") {
                handleLoginSubmit()
            }
        }
    }

    const handleLoginSubmit = async () => {
        handleSpinner()
        if (values.email !== "" || values.password !== "") {
            try {
                const dataVal = "email=" + values.email + "&pass=" + values.password
                const response = await loginAPI(dataVal)
                if (response.status === 200) {
                    window.location.href = window.location.href?.replace(Env.baseUI_URL, "")

                    localStorage.setItem('uInfo', JSON.stringify(response.data.data))
                    localStorage.setItem('uInfoBup', JSON.stringify(response.data.data))

                    response.data.data?.channels?.map((v, i) => {
                        localStorage.setItem("c" + (i + 1), response.data.data?.channels[i]?.whatsapp)
                        localStorage.setItem("cObj", JSON.stringify(response.data?.data?.channels))
                    })

                    localStorage.setItem("isDemo", false)

                    localStorage.removeItem("userEmailT")
                    localStorage.removeItem("userNameT")

                    localStorage.setItem("userActivity", false)
                    localStorage.setItem('botLeftSidebar', 'false')
                    handleSpinner()
                } else {
                    handleSpinner()
                    setValues({ email: '', password: '', showPassword: false })
                    Logout()
                }
            } catch (error) {
                handleSpinner()
                setValues({ email: '', password: '', showPassword: false })
            }
        } else { handleSpinner() }
    }
    return (
        <Dialog open={open} fullWidth={true} maxWidth={"sm"} onClose={() => onCloseHere(false)} TransitionComponent={Transition}>
            <DialogTitle style={{ background: WtColor.LineColor, color: WtColor.TextMidGrey }}>Login </DialogTitle>
            <DialogContent>
                <div className="pt-4 pb-3">
                    <TextField fullWidth id="email" type={"email"} label="Email" value={values.email} defaultValue={localStorage.getItem("userEmailT") ? localStorage.getItem("userEmailT") : ""} onChange={handleChange('email')} variant="outlined" required />
                    <FormControl fullWidth className="mt-3" variant="outlined">
                        <InputLabel htmlFor="password">Password</InputLabel>
                        <OutlinedInput id="password" type={values.showPassword ? 'text' : 'password'} value={values.password} onKeyDown={(e) => handleOnKeyDown(e)} onChange={handleChange('password')} endAdornment={
                            <InputAdornment position="end">
                                <IconButton aria-label="toggle password Visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end" >{values.showPassword ? <VisibilityOff /> : <Visibility />}</IconButton>
                            </InputAdornment>} label="Password" required />
                    </FormControl>
                </div>

                <br />
                <hr />
                <div className="mt-4" style={{ display: "flex", paddingTop: '10px', borderTop: '1px solid ' + WtColor.LineColor }}>
                    <div style={{ flex: 1 }}></div>
                    <div>
                        <button style={ValidButtonStyle} onClick={() => handleLoginSubmit()} className="btn btn-sm rounded-3 ps-3 pe-3 pb-1 text-white theme_bg">Login &nbsp; {startSpinner === true && <Spinner as="span" animation="border" size="sm" role="status" />}</button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}
// End of Login Dialog


// Chat Filter
export function ChatFilter({ open, onClose }) {
    const onCloseHere = (confirm) => { if (onClose) onClose(confirm) }



    // Contacts List Work
    const getChats = useContext(chatContext)
    const getChatsAppliedFilter = useContext(chatContext) // filtered get contacts caller
    // const getFiltedContactsCount = useContext(chatContext)
    const chatFilteredCount = useContext(chatContext)
    // End of Contact List Work

    const setFilterAppliedStatus = useContext(chatContext)
    // const filterAppliedStatus = useContext(chatContext)

    // Label Work
    const lableLs = useContext(globalContext)
    const getLabelLs = useContext(globalContext)
    const labelFields = useContext(chatContext)
    const addLabelFields = useContext(chatContext)
    const removeLabelFields = useContext(chatContext)
    const updateLabelFieldsData = useContext(chatContext)
    const resetLabelFieldData = useContext(chatContext)
    // End of Label Work

    // Custom Field Work
    const attributeLs = useContext(globalContext)
    const getAttributeLs = useContext(globalContext)
    const listCustomField = useContext(chatContext)
    const customFields = useContext(chatContext)
    const addCustomFields = useContext(chatContext)
    const removeCustomFields = useContext(chatContext)
    const updateCustomFieldsData = useContext(chatContext)
    const resetCustomFieldData = useContext(chatContext)
    // End of Custom Field Work

    // Created At Work
    const createAtOpt = useContext(chatContext)
    const updateCreatedAtOpt = useContext(chatContext)
    const createdAtFrom = useContext(chatContext)
    const updateCreatedAtOptFrom = useContext(chatContext)
    const createdAtTo = useContext(chatContext)
    const updateCreatedAtOptTo = useContext(chatContext)
    const finalCreatedFrom = useContext(chatContext)
    const finalCreatedTo = useContext(chatContext)
    const resetCreatedAtData = useContext(chatContext)
    // End of Created At Work

    // Last Seen Work
    const lastSeenOpt = useContext(chatContext)
    const updateLastSeenOpt = useContext(chatContext)
    const lastSeenFrom = useContext(chatContext)
    const updateLastSeenOptFrom = useContext(chatContext)
    const lastSeenTo = useContext(chatContext)
    const updateLastSeenOptTo = useContext(chatContext)
    const finalLastSeenFrom = useContext(chatContext)
    const finalLastSeenTo = useContext(chatContext)
    const resetLastSeenData = useContext(chatContext)
    // End of Last Seen Work


    // Apply Filter
    const applyFilterStatus = useContext(chatContext)
    const setApplyFilterStatus = useContext(chatContext)
    const setResetFilterStatus = useContext(chatContext)
    // End of Apply Filter

    const resetAllFilter = useContext(chatContext)



    const ValidButtonStyle = { background: WtColor.LineColor, color: WtColor.BaseColor, fontWeight: "bold", textTransform: "none", boxShadow: "none" }

    // Label Handling Work
    let discardLabelsLs = []
    let labIdInclude = labelFields.labelFields?.filter((v) => { return v['l_action'] === 'include' }).map((v) => {
        discardLabelsLs.push(v['l_id'])
        return v['l_id']
    })
    let labIdExclude = labelFields.labelFields?.filter((v) => { return v['l_action'] === 'exclude' }).map((v) => {
        discardLabelsLs.push(v['l_id'])
        return v['l_id']
    })
    // Label Handling Work

    // Custom Field Handling Work
    let discardCustomFieldLs = []
    let customFieldList = customFields.customFields?.filter((v) => { return v['cf_id'] !== '' && v['cf_type'] !== '' && v['cf_key'] !== '' && v['cf_operator'] !== '' && v['cf_value'] !== '' }).map((v) => {
        discardCustomFieldLs.push(v['cf_key'])
        return v
    })
    // console.log("CF:" + JSON.stringify(customFieldList))
    // End of Custom Field Handling Work


    // Apply Filter Work
    const applyFilter = () => {
        getChatsAppliedFilter.getChatsAppliedFilter(chatFilteredCount.chatFilteredCount + 20, 0, labIdInclude.join(","), labIdExclude.join(","), customFieldList, finalCreatedFrom.finalCreatedFrom, finalCreatedTo.finalCreatedTo, finalLastSeenFrom.finalLastSeenFrom, finalLastSeenTo.finalLastSeenTo, "first_time")
        // getFiltedContactsCount.getFiltedContactsCount(labIdInclude.join(","), labIdExclude.join(","), customFieldList, finalCreatedFrom.finalCreatedFrom, finalCreatedTo.finalCreatedTo, finalLastSeenFrom.finalLastSeenFrom, finalLastSeenTo.finalLastSeenTo)
        setApplyFilterStatus.setApplyFilterStatus(false)
        setResetFilterStatus.setResetFilterStatus(false)
        setFilterAppliedStatus.setFilterAppliedStatus(true)
        onCloseHere(true)
    }
    // End of Apply Filter Work

    // Reset Filter Work
    const applyResetFilter = () => {
        resetAllFilter.resetAllFilter()
        getChats.getChats('inbox', 'all', 0, 20, "first_time")
        setApplyFilterStatus.setApplyFilterStatus(false)
        onCloseHere(true)
    }
    // End of Reset Filter Work


    useEffect(() => {
        getLabelLs.getLabelLs()
        getAttributeLs.getAttributeLs()
    }, [])






    const form_item_ui_style = { outline: "none", marginRight: "10px", borderRadius: "5px", padding: "4px", border: "1px solid " + WtColor.CloudyGrey, color: WtColor.TextMidGrey }
    const form_item_ui_success_style = { outline: "none", marginRight: "10px", borderRadius: "5px", padding: "4px", border: "1px solid " + WtColor.BaseColor, color: WtColor.TextMidGrey }
    const RadioBtnUIStyle = { color: WtColor.TextDarkColor, '&.Mui-checked': { color: WtColor.BaseColor } }
    return (
        <Dialog open={open} fullWidth={true} maxWidth={"md"} onClose={() => onCloseHere(false)} TransitionComponent={Transition}>
            <DialogTitle style={{ background: WtColor.LineColor, color: WtColor.TextMidGrey }}>
                Advance Chat Filter <Close className="float-end hand" onClick={() => onCloseHere(false)} />
            </DialogTitle>
            <DialogContent>
                <Container fluid>
                    <div className="mt-2 ms-3" style={{ display: "flex" }}>
                        <p style={{ flex: "1", color: WtColor.TextLightGrey }}>&nbsp; </p>
                        <div style={{ display: "flex", marginRight: "30px" }}>
                            <div>
                                <button style={ValidButtonStyle} onClick={() => applyResetFilter()} className="btn btn-sm me-3 rounded-3 ps-3 pe-3 pb-1 text-white theme_grey">Reset</button>
                            </div>
                            <div>
                                <button disabled={applyFilterStatus.applyFilterStatus ? false : true} style={ValidButtonStyle} onClick={() => applyFilter()} className="btn btn-sm me-3 rounded-3 ps-3 pe-3 pb-1 text-white theme_grey">Apply Filter</button>
                            </div>
                        </div>
                    </div>
                    <Container className='ms-2 campaignList' style={{ height: "550px" }} fluid>
                        <Row className="label_work">
                            <Col>
                                <p style={{ color: WtColor.TextDarkColor, fontSize: "18px" }} className="fw-bold">Labels&nbsp;
                                    {
                                        discardLabelsLs?.length !== 0 &&
                                        <Tooltip title="Reset Label Filter" placement='bottom'>
                                            <ReplayOutlined onClick={() => resetLabelFieldData.resetLabelFieldData()} className="hand" style={{ color: WtColor.TextLightGrey, marginTop: '-3px', fontSize: "18px" }} />
                                        </Tooltip>
                                    }
                                </p>
                                <div>
                                    {
                                        labelFields.labelFields?.map((v, i) => {
                                            return (
                                                <div style={{ display: "flex", fontSize: "16px", marginBottom: "6px" }} key={i}>
                                                    <select value={v.l_id} name="l_id" onChange={(e) => updateLabelFieldsData.updateLabelFieldsData(i, e)} style={v.l_id === "" ? form_item_ui_style : form_item_ui_success_style}>
                                                        <option value="">Select Label</option>
                                                        {
                                                            lableLs.lableLs
                                                                .map((v1, i1) => {
                                                                    let showStatus = discardLabelsLs?.includes(v1._id)
                                                                    return (
                                                                        <option style={{ display: showStatus ? 'none' : 'block' }} value={v1._id} key={i1}>{v1.label_name}</option>
                                                                    )
                                                                })
                                                        }
                                                    </select>
                                                    <select value={v.l_action} name="l_action" onChange={(e) => updateLabelFieldsData.updateLabelFieldsData(i, e)} style={v.l_action === "" ? form_item_ui_style : form_item_ui_success_style}>
                                                        <option value="">Select Action</option>
                                                        <option value="include">Include This</option>
                                                        <option value="exclude">Exclude This</option>
                                                    </select>
                                                    <Close style={{ color: "#fff", display: i === 0 ? "block" : "none" }} />
                                                    <Close onClick={() => removeLabelFields.removeLabelFields(i)} className='fw-bold hand' style={{ display: i === 0 ? "none" : "block", color: WtColor.RedColor, marginTop: "6px" }} />
                                                </div>
                                            )
                                        })
                                    }
                                    {
                                        discardLabelsLs.length === labelFields.labelFields.length &&
                                        <p onClick={() => addLabelFields.addLabelFields()} className='hand' style={{ color: WtColor.BaseColor }}>+ Add new label</p>
                                    }
                                </div>
                            </Col>
                        </Row>
                        <Row className="custom_field_work mt-3">
                            <Col>
                                <p style={{ color: WtColor.TextDarkColor, fontSize: "18px" }} className="fw-bold">Custom Fields&nbsp;
                                    {
                                        discardCustomFieldLs?.length !== 0 &&
                                        <Tooltip title="Reset Custom Field Filter" placement='bottom'>
                                            <ReplayOutlined onClick={() => resetCustomFieldData.resetCustomFieldData()} className="hand" style={{ color: WtColor.TextLightGrey, marginTop: '-3px', fontSize: "18px" }} />
                                        </Tooltip>
                                    }
                                </p>
                                <div>
                                    {
                                        customFields.customFields?.map((v, i) => {
                                            return (
                                                <div style={{ display: "flex", fontSize: "16px", marginBottom: "6px" }} key={i}>
                                                    {/* Select Custom Field Work */}
                                                    <select value={[v.cf_id, v.cf_type, v.cf_key]} name="cf_id" onChange={(e) => updateCustomFieldsData.updateCustomFieldsData(i, e)} style={v.cf_id === "" ? form_item_ui_style : form_item_ui_success_style}>
                                                        <option value="">Select Custom Field</option>
                                                        {
                                                            attributeLs.attributeLs?.map((v1, i1) => {
                                                                let showStatus = discardCustomFieldLs?.includes(v1.field_key)
                                                                return (
                                                                    <option style={{ display: showStatus ? 'none' : 'block' }} value={[v1._id, v1.field_type, v1.field_key]} key={i1}>{v1.field_name}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                    {/* End of Select Custom Field Work */}

                                                    {/* Select Operator Work */}
                                                    {
                                                        (v.cf_type === "text" || v.cf_type === "link") &&
                                                        <select value={v.cf_operator} name="cf_operator" onChange={(e) => updateCustomFieldsData.updateCustomFieldsData(i, e)} style={v.cf_operator === "" ? form_item_ui_style : form_item_ui_success_style}>
                                                            <option value="">Select Operation</option>
                                                            <option value="contains">contains</option>
                                                            <option value="eq">equal to</option>
                                                            <option value="starts_with">starts with</option>
                                                            <option value="ends_with">ends with</option>
                                                            <option value="not_contains">not contains</option>
                                                        </select>
                                                    }
                                                    {
                                                        v.cf_type === "number" &&
                                                        <select value={v.cf_operator} name="cf_operator" onChange={(e) => updateCustomFieldsData.updateCustomFieldsData(i, e)} style={v.cf_operator === "" ? form_item_ui_style : form_item_ui_success_style}>
                                                            <option value="">Select Operation</option>
                                                            <option value="eq">is equal to</option>
                                                            <option value="ne">doesn't equal to</option>
                                                            <option value="contains">contains</option>
                                                            <option value="eq">=</option>
                                                            <option value="lt">&lt;</option>
                                                            <option value="lte">&lt;=</option>
                                                            <option value="gt">&gt;</option>
                                                            <option value="gte">&gt;=</option>
                                                            <option value="ne">!=</option>
                                                        </select>
                                                    }
                                                    {
                                                        v.cf_type === "date" &&
                                                        <select value={v.cf_operator} name="cf_operator" onChange={(e) => updateCustomFieldsData.updateCustomFieldsData(i, e)} style={v.cf_operator === "" ? form_item_ui_style : form_item_ui_success_style}>
                                                            <option value="">Select Operation</option>
                                                            <option value="eq">=</option>
                                                            <option value="lt">&lt;</option>
                                                            <option value="gt">&gt;</option>
                                                        </select>
                                                    }
                                                    {
                                                        (v.cf_type === "checkbox" || v.cf_type === "list") &&
                                                        <select value={v.cf_operator} name="cf_operator" onChange={(e) => updateCustomFieldsData.updateCustomFieldsData(i, e)} style={v.cf_operator === "" ? form_item_ui_style : form_item_ui_success_style}>
                                                            <option value="">Select Operation</option>
                                                            <option value="eq">equal to</option>
                                                            <option value="ne">not equal to</option>
                                                        </select>
                                                    }
                                                    {/* End of Select Operator Work */}

                                                    {/* Select Value Work */}
                                                    {
                                                        v.cf_type === "text" && <input defaultValue={v.cf_value} type="text" placeholder="Enter Text" name="cf_value" onChange={(e) => updateCustomFieldsData.updateCustomFieldsData(i, e)} style={v.cf_value === "" ? form_item_ui_style : form_item_ui_success_style} />
                                                    }
                                                    {
                                                        v.cf_type === "number" && <input defaultValue={v.cf_value} type="number" placeholder="Enter Number" name="cf_value" onChange={(e) => updateCustomFieldsData.updateCustomFieldsData(i, e)} style={v.cf_value === "" ? form_item_ui_style : form_item_ui_success_style} />
                                                    }
                                                    {
                                                        v.cf_type === "link" && <input defaultValue={v.cf_value} type="url" placeholder="Enter Link or URL" name="cf_value" onChange={(e) => updateCustomFieldsData.updateCustomFieldsData(i, e)} style={v.cf_value === "" ? form_item_ui_style : form_item_ui_success_style} />
                                                    }
                                                    {
                                                        v.cf_type === "date" && <input defaultValue={v.cf_value} type="date" placeholder="Enter Date" name="cf_value" onChange={(e) => updateCustomFieldsData.updateCustomFieldsData(i, e)} style={v.cf_value === "" ? form_item_ui_style : form_item_ui_success_style} />
                                                    }
                                                    {
                                                        v.cf_type === "checkbox" &&
                                                        <select value={v.cf_value} name="cf_value" onChange={(e) => updateCustomFieldsData.updateCustomFieldsData(i, e)} style={v.cf_value === "" ? form_item_ui_style : form_item_ui_success_style}>
                                                            <option value="">Select Value</option>
                                                            <option value="true">True</option>
                                                            <option value="false">False</option>
                                                        </select>
                                                    }
                                                    {
                                                        v.cf_type === "list" &&
                                                        <select defaultValue={v.cf_value} name="cf_value" onChange={(e) => updateCustomFieldsData.updateCustomFieldsData(i, e)} style={v.cf_value === "" ? form_item_ui_style : form_item_ui_success_style}>
                                                            <option value="">Select Value</option>
                                                            {
                                                                listCustomField.listCustomField?.map((v1, i1) => {
                                                                    return (
                                                                        <option value={v1} key={i1}>{v1}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    }
                                                    {/* End of Select Value Work */}
                                                    <Close style={{ color: "#fff", display: i === 0 ? "block" : "none" }} />
                                                    <Close onClick={() => removeCustomFields.removeCustomFields(i)} className='fw-bold hand' style={{ display: i === 0 ? "none" : "block", color: WtColor.RedColor, marginTop: "6px" }} />
                                                </div>
                                            )
                                        })
                                    }
                                    {
                                        discardCustomFieldLs.length === customFields.customFields.length &&
                                        <p onClick={() => addCustomFields.addCustomFields()} className='hand' style={{ color: WtColor.BaseColor }}>+ Add new custom field</p>
                                    }
                                </div>
                            </Col>
                        </Row>
                        <Row className="created_at mt-3">
                            <Col>
                                <p style={{ color: WtColor.TextDarkColor, fontSize: "18px" }} className="fw-bold">Created At&nbsp;
                                    {
                                        createAtOpt.createAtOpt !== "none" &&
                                        <Tooltip title="Reset Created At Filter" placement='bottom'>
                                            <ReplayOutlined onClick={() => resetCreatedAtData.resetCreatedAtData()} className="hand" style={{ color: WtColor.TextLightGrey, marginTop: '-3px', fontSize: "18px" }} />
                                        </Tooltip>
                                    }
                                </p>
                                <RadioGroup row name="row-radio-buttons-group" value={createAtOpt.createAtOpt} onChange={updateCreatedAtOpt.updateCreatedAtOpt}>
                                    <FormControlLabel value="none" style={{ display: "none" }} control={<Radio sx={RadioBtnUIStyle} />} label="None" />
                                    <FormControlLabel value="today" control={<Radio sx={RadioBtnUIStyle} />} label="Today" />
                                    <FormControlLabel value="week" control={<Radio sx={RadioBtnUIStyle} />} label="This Week" />
                                    <FormControlLabel value="month" control={<Radio sx={RadioBtnUIStyle} />} label="This Month" />
                                    <FormControlLabel value="custom" control={<Radio sx={RadioBtnUIStyle} />} label="Custom Range" />
                                </RadioGroup>
                                {
                                    (createAtOpt.createAtOpt === 'today' || createAtOpt.createAtOpt === 'week' || createAtOpt.createAtOpt === 'month') &&
                                    <div>
                                        <p style={{ color: WtColor.TextLightGrey }}>{createdAtFrom.createdAtFrom} to {createdAtTo.createdAtTo}</p>
                                    </div>
                                }
                                {
                                    createAtOpt.createAtOpt === 'custom' &&
                                    <div className='mt-3' style={{ display: "flex" }}>
                                        <div className="me-2">
                                            <label htmlFor='created_at_from' style={{ color: WtColor.TextLightGrey }}>From</label>
                                            <input value={createdAtFrom.createdAtFrom} id="created_at_from" type="date" max={moment().format('YYYY-MM-DD')} placeholder="Enter Date" name="cf_value" onChange={(e) => updateCreatedAtOptFrom.updateCreatedAtOptFrom(e.target.value)} style={createdAtFrom.createdAtFrom === '' ? form_item_ui_style : form_item_ui_success_style} />
                                        </div>
                                        <div>
                                            <label htmlFor='created_at_from' style={{ color: WtColor.TextLightGrey }}>To</label>
                                            <input value={createdAtTo.createdAtTo} id="created_at_to" type="date" min={ShowDateFilter(finalCreatedFrom.finalCreatedFrom)} max={moment().format('YYYY-MM-DD')} placeholder="Enter Date" name="cf_value" disabled={createdAtFrom.createdAtFrom === '' ? true : false} onChange={(e) => updateCreatedAtOptTo.updateCreatedAtOptTo(e.target.value)} style={createdAtTo.createdAtTo === '' ? form_item_ui_style : form_item_ui_success_style} />
                                        </div>
                                    </div>
                                }
                            </Col>
                        </Row>
                        <Row className="last_seen_at mt-3 mb-5 pb-5">
                            <Col>
                                <p style={{ color: WtColor.TextDarkColor, fontSize: "18px" }} className="fw-bold">Last Seen&nbsp;
                                    {
                                        lastSeenOpt.lastSeenOpt !== "none" &&
                                        <Tooltip title="Reset Last Seen Filter" placement='bottom'>
                                            <ReplayOutlined onClick={() => resetLastSeenData.resetLastSeenData()} className="hand" style={{ color: WtColor.TextLightGrey, marginTop: '-3px', fontSize: "18px" }} />
                                        </Tooltip>
                                    }
                                </p>
                                <RadioGroup row name="row-radio-buttons-group" value={lastSeenOpt.lastSeenOpt} onChange={updateLastSeenOpt.updateLastSeenOpt}>
                                    <FormControlLabel value="none" style={{ display: "none" }} control={<Radio sx={RadioBtnUIStyle} />} label="None" />
                                    <FormControlLabel value="today" control={<Radio sx={RadioBtnUIStyle} />} label="Today" />
                                    <FormControlLabel value="week" control={<Radio sx={RadioBtnUIStyle} />} label="This Week" />
                                    <FormControlLabel value="month" control={<Radio sx={RadioBtnUIStyle} />} label="This Month" />
                                    <FormControlLabel value="custom" control={<Radio sx={RadioBtnUIStyle} />} label="Custom Range" />
                                </RadioGroup>
                                {
                                    (lastSeenOpt.lastSeenOpt === 'today' || lastSeenOpt.lastSeenOpt === 'week' || lastSeenOpt.lastSeenOpt === 'month') &&
                                    <div>
                                        <p style={{ color: WtColor.TextLightGrey }}>{lastSeenFrom.lastSeenFrom} to {lastSeenTo.lastSeenTo}</p>
                                    </div>
                                }
                                {
                                    lastSeenOpt.lastSeenOpt === 'custom' &&
                                    <div className='mt-3' style={{ display: "flex" }}>
                                        <div className="me-2">
                                            <label htmlFor='last_seen_from' style={{ color: WtColor.TextLightGrey }}>From</label>
                                            <input value={lastSeenFrom.lastSeenFrom} id="last_seen_from" type="date" max={moment().format('YYYY-MM-DD')} placeholder="Enter Date" name="cf_value" onChange={(e) => updateLastSeenOptFrom.updateLastSeenOptFrom(e.target.value)} style={lastSeenFrom.lastSeenFrom === '' ? form_item_ui_style : form_item_ui_success_style} />
                                        </div>
                                        <div>
                                            <label htmlFor='last_seen_to' style={{ color: WtColor.TextLightGrey }}>To</label>
                                            <input value={lastSeenTo.lastSeenTo} id="last_seen_to" type="date" min={ShowDateFilter(finalLastSeenFrom.finalLastSeenFrom)} max={moment().format('YYYY-MM-DD')} placeholder="Enter Date" name="cf_value" disabled={lastSeenFrom.lastSeenFrom === '' ? true : false} onChange={(e) => updateLastSeenOptTo.updateLastSeenOptTo(e.target.value)} style={lastSeenTo.lastSeenTo === '' ? form_item_ui_style : form_item_ui_success_style} />
                                        </div>
                                    </div>
                                }
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </DialogContent>
        </Dialog>
    )
}
// End of Chat Filter


// Featured Chatbot Template Dialog
export function FeaturedChatBotDialog({ open, v, onClose }) {
    const onCloseHere = (confirm) => { if (onClose) onClose(confirm) }

    return (
        <Dialog open={open} fullWidth={true} maxWidth={"sm"} onClose={() => onCloseHere(false)} TransitionComponent={Transition}>
            <DialogTitle style={{ background: WtColor.LineColor, color: WtColor.TextMidGrey }}>{v?.title}</DialogTitle>
            <DialogContent>
                <DialogContentText className="mt-4" style={{ color: '#162c6f' }}>
                    Real Estate companies can make use of this chatbot template to let their buyers/propects know about payment schedule once they decide on the property. This bot is designed in a way, to even collect certain payments.
                </DialogContentText>
                <button className="btn btn-sm mt-3" style={{ background: '#cbd5e0', fontSize: '12px', borderRadius: '4px', paddingTop: '2px 8px 4px 8px' }}>Booking / Scheduling</button><br />
                <button className="btn fw-bold mt-3" style={{ background: WtColor.BaseColor, color: 'white', fontSize: '17px', borderRadius: '6px', padding: '0.5em 2em' }}>Try on WhatsApp</button>
            </DialogContent>
        </Dialog>
    )
}
// End of Featured Chatbot Template Dialog